import { render, staticRenderFns } from "./SenkronAyarKarti.vue?vue&type=template&id=04b5a3bd"
import script from "./SenkronAyarKarti.vue?vue&type=script&lang=ts"
export * from "./SenkronAyarKarti.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports